// 正式环境配置-线上
module.exports = {
  urlUser: "",
  urlCommon: "",
  baseURL: ""
}
